webpackJsonp([9],{

/***/ "3CUW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"about_box_photos":"about_box_photos__1E0ba","about_photos_section":"about_photos_section__2m-aZ","about_box_title":"about_box_title__2AO7V","about_photo_description":"about_photo_description__fFhIs","about_photo_image":"about_photo_image__3U6e-","about_photo_container":"about_photo_container__acl68","about_photo_image_half":"about_photo_image_half__3PLaR"};

/***/ }),

/***/ "HgQI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"about_layout":"about_layout___JFwY","about_column":"about_column__2tVrE","map":"map__3zFqu","map_caption":"map_caption__364ME"};

/***/ }),

/***/ "LOGg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./components/card/index.js
var card = __webpack_require__("MTo3");

// CONCATENATED MODULE: ./components/about/about-weather-station.js



/**
 * The AboutWeatherStation component is used on the About page to show information about
 * the weather station.
 *
 * props: none
 */

var _ref = Object(preact_min["h"])(
	card["a" /* default */],
	{ cardTitle: "Weather station" },
	Object(preact_min["h"])(
		"p",
		null,
		"The weather station is a wireless Davis Vantage Pro 2 unit, located in the western part of the Howick area. Howick is an eastern suburb of Auckland, New Zealand. The station was set up in early December of 2009."
	),
	Object(preact_min["h"])(
		"p",
		null,
		"The weather station is comprised of 3 parts: the indoor console, the anemometer (for wind speed and direction), and ISS (Integrated Sensor Suite). The ISS combines the rain gauge, temperature and humidity sensors into a single unit. The temperature and humidity sensors are housed within a durable fan-aspirated solar radiation shield in order to maximise accuracy. I spent some considerable time early in the weather station's early history calibrating the rain gauge to try get the readings as accurate as I can. Both the anemometer and the ISS transmit their data to the indoor console, which is connected to a PC by USB cable."
	),
	Object(preact_min["h"])(
		"p",
		null,
		"The data sent to the PC is continuously monitored by ",
		Object(preact_min["h"])(
			"a",
			{ href: "https://cumuluswiki.wxforum.net/a/About_Cumulus" },
			"Cumulus"
		),
		", which stores all data received and keeps track of all the daily extremes and weather station records. Cumulus uploads live data to the website at regular intervals."
	)
);

var AboutWeatherStation = function AboutWeatherStation() {
	return _ref;
};

/* harmony default export */ var about_weather_station = (AboutWeatherStation);
// CONCATENATED MODULE: ./components/about/about-website.js



/**
 * The AboutWebsite component is used on the About page to show information about
 * the website itself.
 *
 * props: none
 */

var about_website__ref = Object(preact_min["h"])(
	card["a" /* default */],
	{ cardTitle: "Website" },
	Object(preact_min["h"])(
		"p",
		null,
		"This website presents weather information as recorded by the weather station. It is hosted locally, in central Auckland."
	),
	Object(preact_min["h"])(
		"p",
		null,
		"The website has been rebuilt in late 2018 as a mobile-friendly Progressive Web App. This means it is very fast and efficient, caching many resources to reduce your data usage. It also means you can add it to the home screen on Android phones, and the website will launch just like a native app."
	)
);

var AboutWebsite = function AboutWebsite() {
	return about_website__ref;
};

/* harmony default export */ var about_website = (AboutWebsite);
// EXTERNAL MODULE: ./components/feedback-email/index.js
var feedback_email = __webpack_require__("NGFW");

// CONCATENATED MODULE: ./components/about/about-contact.js




/**
 * AboutContact component is used on the About page to display contact information.
 *
 * props: none
 */

var about_contact__ref = Object(preact_min["h"])(
	card["a" /* default */],
	{ cardTitle: 'Contact me' },
	Object(preact_min["h"])(
		'p',
		null,
		'Got any comments, questions or suggestions? Or maybe you\'ve found a bug on the website? You can contact me at the following address:'
	),
	Object(preact_min["h"])(
		'p',
		null,
		Object(preact_min["h"])(feedback_email["a" /* default */], null)
	)
);

var AboutContact = function AboutContact() {
	return about_contact__ref;
};

/* harmony default export */ var about_contact = (AboutContact);
// CONCATENATED MODULE: ./components/about/about-data-usage.js



/**
 * The AboutDataUsage component is used on the About page to display information concerning
 * external data usage of the weather data.
 *
 * props: none
 */

var about_data_usage__ref = Object(preact_min["h"])(
	card["a" /* default */],
	{ cardTitle: "Data usage" },
	Object(preact_min["h"])(
		"p",
		null,
		"You may use the data on this website for projects, research, etc. but please do acknowledge the source. If you are unable to find the data you need in an easy-to-download format, please contact me. I will be happy to help."
	)
);

var AboutDataUsage = function AboutDataUsage() {
	return about_data_usage__ref;
};

/* harmony default export */ var about_data_usage = (AboutDataUsage);
// CONCATENATED MODULE: ./components/about/about-licenses.js



/**
 * The AboutLicenses component is used on the About page to show license information
 * about any third party libraries or resources used in the web application.
 *
 * props: none
 */

var about_licenses__ref = Object(preact_min["h"])(
  card["a" /* default */],
  { cardTitle: "Licenses" },
  Object(preact_min["h"])(
    "p",
    null,
    "The rainfall icons displayed on the home page when it is raining are created by Stardock (http://www.stardock.com). Use of the icons requires a link their ",
    Object(preact_min["h"])(
      "a",
      { target: "_blank", href: "assets/licenses/stardock-permissions.txt" },
      "permissions file"
    ),
    "."
  )
);

var AboutLicenses = function AboutLicenses() {
  return about_licenses__ref;
};

/* harmony default export */ var about_licenses = (AboutLicenses);
// CONCATENATED MODULE: ./components/about/about-me.js



/**
 * The AboutMe component is used on the About page to display information about me,
 * the weather station owner!
 *
 * props: none
 */

var about_me__ref = Object(preact_min["h"])(
	card["a" /* default */],
	{ cardTitle: "About me" },
	Object(preact_min["h"])(
		"p",
		null,
		"Hi, I'm David! I run the Howick Weather Station. I love watching and recording the weather, and also enjoy sharing the data with the community. I'm a web developer by trade and this website is my own creation - I hope you enjoy it!"
	)
);

var AboutMe = function AboutMe() {
	return about_me__ref;
};

/* harmony default export */ var about_me = (AboutMe);
// EXTERNAL MODULE: ./components/about/style.scss
var style = __webpack_require__("3CUW");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// CONCATENATED MODULE: ./components/about/about-photos.js




/**
 * The AboutPhotos component is used on the About page to show photos of the weather station
 * components with captions.
 *
 * props: none
 */

var about_photos_AboutPhotos = function AboutPhotos() {
	return Object(preact_min["h"])(
		card["a" /* default */],
		{ cardTitle: 'Weather station photos', noMargin: true },
		Object(preact_min["h"])(
			'div',
			{ 'class': style_default.a.about_box_photos },
			Object(preact_min["h"])(
				'div',
				{ 'class': style_default.a.about_photos_section },
				Object(preact_min["h"])(
					'div',
					{ 'class': style_default.a.about_photo_description },
					'Outdoor components'
				),
				Object(preact_min["h"])(
					'div',
					{ 'class': style_default.a.about_photo_container },
					Object(preact_min["h"])('img', { 'class': style_default.a.about_photo_image_half,
						src: 'assets/img/station-iss-2018-600w.jpg',
						alt: 'Main outdoor unit' }),
					Object(preact_min["h"])('img', { 'class': style_default.a.about_photo_image_half,
						src: 'assets/img//station-anemometer-2018-600w.jpg',
						alt: 'Anemometer' })
				)
			),
			Object(preact_min["h"])(
				'div',
				{ 'class': style_default.a.about_photos_section },
				Object(preact_min["h"])(
					'div',
					{ 'class': style_default.a.about_photo_description },
					'Inside the tipping bucket rain gauge'
				),
				Object(preact_min["h"])(
					'div',
					{ 'class': style_default.a.about_photo_container },
					Object(preact_min["h"])('img', { 'class': style_default.a.about_photo_image,
						src: 'assets/img/rain-gauge-inside-2018-1200w.jpg',
						alt: 'Rain gauge tipping bucket' })
				)
			),
			Object(preact_min["h"])(
				'div',
				{ 'class': style_default.a.about_photos_section },
				Object(preact_min["h"])(
					'div',
					{ 'class': style_default.a.about_photo_description },
					'Indoor receiver console'
				),
				Object(preact_min["h"])(
					'div',
					{ 'class': style_default.a.about_photo_container },
					Object(preact_min["h"])('img', { 'class': style_default.a.about_photo_image,
						src: 'assets/img/station-console-2018-1200w.jpg',
						alt: 'Weather station console' })
				)
			)
		)
	);
};

/* harmony default export */ var about_photos = (about_photos_AboutPhotos);
// EXTERNAL MODULE: ./routes/about/style.scss
var about_style = __webpack_require__("HgQI");
var about_style_default = /*#__PURE__*/__webpack_require__.n(about_style);

// EXTERNAL MODULE: ./components/page-title/index.js
var page_title = __webpack_require__("O7V0");

// CONCATENATED MODULE: ../node_modules/babel-loader/lib??ref--0!./routes/about/index.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var about__ref = Object(preact_min["h"])(
	page_title["a" /* default */],
	null,
	'About Howick Weather Station'
);

var _ref2 = Object(preact_min["h"])(about_weather_station, null);

var _ref3 = Object(preact_min["h"])(about_website, null);

var _ref4 = Object(preact_min["h"])(about_me, null);

var _ref5 = Object(preact_min["h"])(about_contact, null);

var _ref6 = Object(preact_min["h"])(about_data_usage, null);

var _ref7 = Object(preact_min["h"])(about_licenses, null);

var _ref8 = Object(preact_min["h"])(about_photos, null);

var about_AboutPage = function (_Component) {
	_inherits(AboutPage, _Component);

	function AboutPage() {
		_classCallCheck(this, AboutPage);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	AboutPage.prototype.componentDidMount = function componentDidMount() {
		this.context.titleService.update('About');
		this.context.tracking.recordPageView();
	};

	AboutPage.prototype.render = function render(props) {
		return Object(preact_min["h"])(
			'div',
			{ 'class': about_style_default.a.about },
			about__ref,
			Object(preact_min["h"])(
				'div',
				{ 'class': about_style_default.a.about_layout },
				Object(preact_min["h"])(
					'div',
					{ 'class': about_style_default.a.about_column },
					_ref2,
					_ref3
				),
				Object(preact_min["h"])(
					'div',
					{ 'class': about_style_default.a.about_column },
					_ref4,
					_ref5,
					_ref6,
					_ref7
				)
			),
			Object(preact_min["h"])(
				card["a" /* default */],
				{ cardTitle: 'Weather Station Location' },
				Object(preact_min["h"])(
					'div',
					{ 'class': about_style_default.a.map },
					Object(preact_min["h"])(
						'div',
						{ 'class': about_style_default.a.map_caption },
						'Map by Google'
					)
				)
			),
			_ref8
		);
	};

	return AboutPage;
}(preact_min["Component"]);

/* harmony default export */ var about = __webpack_exports__["default"] = (about_AboutPage);

/***/ })

});


// WEBPACK FOOTER //
// route-about.chunk.961ca.js